import { isAfter, isBefore, type Interval, isWithinInterval } from 'date-fns';

export const isActivePeriod = (
  period: Interval,
  { referenceDate = new Date() } = {},
) => isWithinInterval(referenceDate, period);

export const isFuturePeriod = (
  period: Interval,
  { referenceDate = new Date() } = {},
) => isAfter(period.start, referenceDate);

export const isPastPeriod = (
  period: Interval,
  { referenceDate = new Date() } = {},
) => isBefore(period.end, referenceDate);
